<script>
import BaseModal from 'dashboard/components/dahreply/BaseModal.vue';
import BranchSelectionTable from '../../../../components/BranchSelectionTable.vue';
import { useAlert } from 'dashboard/composables';

export default {
  name: 'AssignBranchesModal',
  components: {
    BaseModal,
    BranchSelectionTable,
  },
  props: {
    branches: {
      type: Array,
      default: () => [],
    }
  },
  computed: {
    serviceId() {
      return this.$route.params.serviceId;
    },
    isLoading() {
      return this.$store.state.branchOptions.isLoading || false;
    },
  },
  data() {
    return {
      selectedBranchIds: this.branches.map(s => s.id),
      isConfirming: false,
    }
  },
  methods: {
    handleSelectionChange(ids) {
      this.selectedBranchIds = ids;
    },
    async handleConfirm() {
      try {
        this.isConfirming = true;

        const payload = {
          service_id: this.serviceId,
          branch_ids: this.selectedBranchIds,
          update_mode: 'replace',
        };

        await this.$store.dispatch(
          'branchServices/bulkAssignBranchesToService',
          {
            serviceId: this.serviceId,
            payload: payload
          }
        );

        useAlert('Branches linked to service');
        this.$emit('refresh');
        this.$emit('close');
      } catch (err) {
        console.error(err);
        useAlert(`Failed to link branches to service: ${err}`);
      } finally {
        this.isConfirming = false;
      }
    },
  }
}
</script>

<template>
  <BaseModal @close="$emit('close')">
    <template #title>Assign Branches</template>

    <!-- Integrated Table -->
    <BranchSelectionTable
      :initialSelectedIds="selectedBranchIds"
      @change="handleSelectionChange"
    />

    <template #footer>
      <div class="flex justify-end gap-3 mt-4">
        <woot-button color-scheme="secondary" @click="$emit('close')" :disabled="isLoading">
          Cancel
        </woot-button>
        <woot-button @click="handleConfirm" :is-loading="isConfirming || isLoading" :disabled="isLoading">
          Assign
        </woot-button>
      </div>
    </template>
  </BaseModal>
</template>